/**
 * custom-main-product.js
 * Pairs with sections/custom-main-product.liquid.
 *
 * assets/pdp-buy-box.js (shared with the live sections/main-product.liquid,
 * not edited here) only reveals the "$total | Add to cart" total once
 * quantity > 1; at quantity 1 the button shows plain "Add to cart". This
 * mockup always shows "$price | Add to cart", even at quantity 1. Rather
 * than editing the shared pdp-buy-box.js (which would change the live
 * section's behavior too), this file re-applies the total/divider directly
 * whenever pdp-buy-box.js's own listeners run, additively.
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function initAlwaysShowTotal(button) {
    var totalEl = button.querySelector('[data-atc-total-price]');
    var dividerEl = button.querySelector('[data-atc-divider]');
    if (!totalEl || !dividerEl) return;

    var scope = button.closest('.product__info-container') || document;
    var qtyInput = scope.querySelector('.quantity__input');
    var sellingPlanInput = scope.querySelector('[data-selling-plan-input]');
    var frequencySelect = scope.querySelector('[data-sf-frequency-select]');
    var sfRadios = scope.querySelectorAll('[data-sf-radio]');

    // Same unit price as pdp-buy-box.js: the selected plan's own
    // data-price-cents (Shopify's selling_plan_allocation price, kept current
    // by subscription-frequency.js) while Subscribe is active, else the
    // variant's regular price. This file loads after subscription-frequency.js,
    // so its listeners run after the plan input / options are synced.
    function unitPriceCents() {
      var unitCents = parseInt(button.getAttribute('data-atc-unit-price'), 10) || 0;
      if (sellingPlanInput && !sellingPlanInput.disabled && frequencySelect && !frequencySelect.closest('[hidden]')) {
        var option = frequencySelect.selectedOptions[0];
        var planCents = option && parseInt(option.dataset.priceCents, 10);
        if (planCents) unitCents = planCents;
      }
      return unitCents;
    }

    function recompute() {
      if (button.disabled) return;
      var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
      totalEl.textContent = formatMoney(unitPriceCents() * qty);
      totalEl.hidden = false;
      dividerEl.hidden = false;
    }

    if (qtyInput) qtyInput.addEventListener('change', recompute);
    if (frequencySelect) frequencySelect.addEventListener('change', recompute);
    sfRadios.forEach(function (radio) {
      radio.addEventListener('change', recompute);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data.variant;
        if (!variant) return;
        button.setAttribute('data-atc-unit-price', variant.price);
        recompute();
      });
    }

    // Run after pdp-buy-box.js's own init (both listen for DOMContentLoaded-
    // time script execution in document order; this file is loaded after
    // it in the section, and this call runs synchronously on top of
    // whatever pdp-buy-box.js already set).
    recompute();
  }

  document.querySelectorAll('.cmp-product [data-atc-unit-price]').forEach(initAlwaysShowTotal);

  // product-form.js writes "Add to cart" / "Sold out" into the submit
  // button's first <span>, which in buy-buttons.liquid is the price total,
  // not the label. Point it at the actual label span.
  function linkSubmitButtonLabel(button) {
    var productForm = button.closest('product-form');
    var label = button.querySelector(':scope > span:not([data-atc-total-price]):not([data-atc-divider])');
    if (!productForm || !label || !window.customElements) return;
    customElements.whenDefined('product-form').then(function () {
      productForm.submitButtonText = label;
    });
  }

  document.querySelectorAll('.cmp-product [data-atc-unit-price]').forEach(linkSubmitButtonLabel);

  // snippets/subscription-frequency.liquid server-renders the One-time
  // card's price, and subscription-frequency.js (shared with the live
  // main-product section) only refreshes the Subscribe card's plan price on
  // variant change. Keep the One-time price on the selected variant too.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    document.querySelectorAll('.cmp-product .sf__card--onetime .sf__price').forEach(function (priceEl) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data.variant;
        if (variant) priceEl.textContent = formatMoney(variant.price);
      });
    });
  }

  // Recharge's storefront script (widget.min.js, from the app embed — not
  // the theme) auto-injects its own subscription widget into every product
  // form, even with the Recharge block disabled in this template. Here the
  // Purchase Frequency block (snippets/subscription-frequency.liquid) owns
  // the subscription UI and the form's single name="selling_plan" input
  // (outside the <form>, linked by its form= attribute). Recharge adds a
  // duplicate dropdown plus its own hidden selling_plan input directly
  // inside the <form>, which keeps its plan id even after the shopper picks
  // One-time purchase. Remove both (CSS in custom-main-product.css hides
  // the widget until then), and keep removing them: Recharge re-injects
  // after Dawn re-renders.
  var RECHARGE_WIDGET =
    '.rc-container-wrapper, [data-widget-container-wrapper], product-form form [name="selling_plan"]';

  function removeRechargeWidget(scope) {
    scope.querySelectorAll(RECHARGE_WIDGET).forEach(function (widget) {
      widget.remove();
    });
  }

  // product-info.js looks up its quantity form as `.product-form__quantity`,
  // which the Quantity Selector block (snippets/cmp-quantity-selector.liquid)
  // deliberately doesn't carry (it would pull in pdp-quantity.css styling).
  // Left null, updateQuantityRules() throws on every variant change before
  // variantChange is published, so nothing subscribed to it (media gallery,
  // backorder badges) ever updates. Point it at the block's own wrapper.
  function linkQuantityForm(productInfo) {
    if (productInfo.quantityForm) return;
    var quantityForm = productInfo.querySelector('#Quantity-Form-' + productInfo.dataset.section);
    if (quantityForm) productInfo.quantityForm = quantityForm;
  }

  if (window.customElements) {
    customElements.whenDefined('product-info').then(function () {
      document.querySelectorAll('product-info.cmp-product').forEach(linkQuantityForm);
    });
  }

  // The Reviews block (snippets/cmp-reviews.liquid) links to the Judge.me
  // Review Widget further down the page; smooth-scroll to it instead of
  // jumping. Without a widget on the page the link is left to the browser.
  function scrollToReviews(event) {
    var link = event.target.closest('.cmp-reviews');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  document.querySelectorAll('.cmp-product').forEach(function (product) {
    removeRechargeWidget(product);
    product.addEventListener('click', scrollToReviews);
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      removeRechargeWidget(product);
    }).observe(product, { childList: true, subtree: true });
  });
})();
